import apiServices from "../common/apiServices";

// Define the tag types related to transaction earnings
export const addTagTypes = ['TransactionEarnings'];

// Enhance the base API service by adding transaction earnings-related tag types
const TransactionEarningsApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Fetch Daily Earnings by User ID (GET request to /transaction-earned-daily)
      getDailyEarningsByUserId: build.query({
        query: ({ sellerId, isActive }) => ({
          url: `/transactions/transaction-earned-daily`,
          params: { sellerId, isActive }, // Pass query parameters
        }),
        providesTags: ['TransactionEarnings'],
      }),
       // Fetch Monthly Earnings by User ID (GET request to /transaction-earned-daily)
       getMonthlyEarningsByUserId: build.query({
        query: ({ sellerId, isActive }) => ({
          url: `/transactions/transaction-earned-month`,
          params: { sellerId, isActive }, // Pass query parameters
        }),
        providesTags: ['TransactionEarnings'],
      }),
       // Fetch Yearly Earnings by User ID (GET request to /transaction-earned-daily)
       getYearlyEarningsByUserId: build.query({
        query: ({ sellerId, isActive }) => ({
          url: `/transactions/transaction-earned-year`,
          params: { sellerId, isActive }, // Pass query parameters
        }),
        providesTags: ['TransactionEarnings'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for each endpoint to be used in components
export const {
  useGetDailyEarningsByUserIdQuery, // Ensure this is exported
  useGetMonthlyEarningsByUserIdQuery,
  useGetYearlyEarningsByUserIdQuery
} = TransactionEarningsApi;

export default TransactionEarningsApi;